import React from 'react';
import { PriceCard } from './Shared';
export const FinalCtaSection = () => {
  return <section id="checkout-section" className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6 scroll-mt-4" data-id="element-68" data-mp="3lu6i1lk45smn">
      <div className="max-w-7xl mx-auto text-center w-[92%] md:w-full" data-id="element-69" data-mp="3quazbdsuirdx">
        <h2 className="text-familia-red font-bold text-3xl sm:text-4xl md:text-5xl mb-4 uppercase tracking-widest text-center" data-id="element-70" data-mp="3vrkyvm9y8jfh">
          You Don't Need to Do Everything.
        </h2>
        <p className="text-familia-gray text-lg md:text-2xl mb-10 md:mb-16" data-id="element-71" data-mp="333f8aiw7s07q">
          You just need a simple place to start. Give yourself a ready-to-use
          system for those moments when you want to help but aren't sure what to
          do next.
        </p>

        <div className="mb-10 md:mb-20 flex justify-center" data-id="element-72" data-mp="3cvkz3paqcblc">
          <PriceCard data-id="element-73" data-mp="2fdus27rg3h25" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-74" data-mp="2fcjl5z2pdt6t">
          {['Cognitive, Movement & Caregiver Resources', '240+ Printable Pages', 'Instant Digital Access', '60-Day Money-Back Guarantee'].map((item, i) => <div key={i} className="bg-familia-card border border-familia-cyan/15 p-4 rounded-xl flex items-center justify-center gap-3" data-id="element-75" data-mp="23lxbc6al8ss1" data-mpi={i}>
              <span className="text-familia-green" data-id="element-76" data-mp="1yl9l3mu6ofyv">✅</span>
              <span className="text-xs font-bold uppercase tracking-wider" data-id="element-77" data-mp="1uma8rh64hgxe">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};